import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import type { CommandResponseFE } from 'domain/command';
import { commandFromRestV1 } from 'domain/mappers/commandFromRestV1';

import type { VehicleCommandInput } from '../API';
import { errorHandler, formatAxiosError, isAxiosError } from './errors';
import { commandsRestApi, correlationHeaders } from './restClient';

const sendCommandFn = async (variables: VehicleCommandInput): Promise<{ data: CommandResponseFE }> => {
    try {
        const response = await commandsRestApi.post<unknown>(
            '/api/v1/commands',
            { vin: variables.vin, command: variables.command },
            correlationHeaders()
        );
        return { data: commandFromRestV1(response.data) };
    } catch (error) {
        const loggableError = isAxiosError(error) ? formatAxiosError(error) : error;
        throw errorHandler('Unexpected error occurred while triggering the command', loggableError);
    }
};

export const commandApi = createApi({
    reducerPath: 'command',
    // Every endpoint runs on `queryFn`, so the base query is never invoked — the command now goes
    // over REST (`POST /api/v1/commands` on the vehicle service), not GraphQL.
    baseQuery: fakeBaseQuery<unknown>(),
    refetchOnMountOrArgChange: true,
    endpoints: builder => ({
        sendCommand: builder.mutation<CommandResponseFE, VehicleCommandInput>({
            queryFn: sendCommandFn,
        }),
    }),
});

export const { useSendCommandMutation } = commandApi;
